import Dexie, { Table } from 'dexie';
import { Operator } from '../domain/operator';
import { Consommable } from '../domain/consommable';
import { mapper } from '../tools/mapping/mapper';
import { AppareilEntity } from './appareil.entity';
import { CanalEntity } from './canal.entity';
import { ConsommableEntity } from './consommable.entity';
import { EndoscopeEntity } from './endoscope.entity';
import { FlaconEntity } from './flacon.entity';
import { GenerateurEntity } from './generateur.entity';
import { InterventionEntity } from './intervention.entity';
import { LastUsedConsommableEntity } from './last-used-consommable.entity';
import { OperatorEntity } from './operator.entity';
import { PointageJournalierEntity } from './pointage-journalier.entity';
import { PointagePauseEntity } from './pointage-pause.entity';
import { PrelevementAirEntity } from './prelevement-air.entity';
import { PrelevementGenerateurDialyseEntity } from './prelevement-generateur.entity';
import { PrelevementQualifSalleEntity } from './prelevement-qualif-salle.entity';
import { PrelevementSurfaceEntity } from './prelevement-surface.entity';
import { PrelevementEntity } from './prelevement.entity';
import { RepriseEntity } from './reprise.entity';
import { SamplingPointEntity } from './sampling-point.entity';
import { SoufflageEntity } from './soufflage.entity';
import { UserEntity } from './user.entity';
import { ZoneCompareEntity } from './zone-compare.entity';
import { ZoneEntity } from './zone.entity';
const IDBExportImport = require('indexeddb-export-import');

export class AppDB extends Dexie {
    public interventions!: Table<InterventionEntity, number>;

    public zones!: Table<ZoneEntity, number>;
    public prelevementAirs!: Table<PrelevementAirEntity, number>;
    public prelevementSurfaces!: Table<PrelevementSurfaceEntity, number>;

    public generateurs!: Table<GenerateurEntity, number>;
    public prelevementGenerateurs!: Table<PrelevementGenerateurDialyseEntity, number>;

    public endoscopes!: Table<EndoscopeEntity, number>;
    public canals!: Table<CanalEntity, number>;

    public prelevementQualifSalles!: Table<PrelevementQualifSalleEntity, number>;
    public appareils!: Table<AppareilEntity, number>;
    public soufflages!: Table<SoufflageEntity, number>;
    public reprises!: Table<RepriseEntity, number>;
    public zoneCompares!: Table<ZoneCompareEntity, number>;

    public prelevements!: Table<PrelevementEntity, number>;
    public samplingPoints!: Table<SamplingPointEntity, number>;
    public flacons!: Table<FlaconEntity, number>;
    public consommables!: Table<ConsommableEntity, number>;
    public lastUsedConsommables!: Table<LastUsedConsommableEntity, number>;

    public users!: Table<UserEntity, number>;
    public operators!: Table<OperatorEntity, number>;

    public pointageJournaliers!: Table<PointageJournalierEntity, number>;
    public pointagePauses!: Table<PointagePauseEntity, number>;

    constructor() {
        super('HH-P');
        this.version(6).stores({
            interventions: '++Id, [Code], IsLastMinute, Code, NomChantier, Status, AdresseChantier, RequiredOn, PlannedDate, SamplerId, *ZoneIds, *GenerateurIds, *EndoscopeIds',

            zones: '++Id, TaskStatus, Code, [Code], ZoneSalle, DateDernierLavage, SamplingDate, ConditionPrelevement, PrelevementQualifSalleId, *PrelevementAirIds, *PrelevementSurfaceIds',
            prelevementAirs: '++Id, Code, [Code], TempsSedimentation, VolumeAirPreleve, Observations, MilieuPrelevement, LieuPrelevement, AutreLieuPrelevement, MethodePrelevementAir, PrelevementId',
            prelevementSurfaces: '++Id, Code, [Code], LieuPrelevement, AutreLieuPrelevement, MilieuPrelevement, Observations, PrelevementId',

            generateurs: '++Id, TaskStatus, Code, [Code], ZoneSalle, SamplingDate, Marque, Modele, NumSerie, NumAppareil, *PrelevementGenerateurDialyseIds',
            prelevementGenerateurs: '++Id, Code, [Code], Localisation, Bicarbonate, Sodium, LocalisationDialyse, AutreLocalisationDialyse, ModeDesinfection, Observations, PrelevementId',

            endoscopes: '++Id, TaskStatus, Code, [Code], ZoneSalle, SamplingDate, Marque, Modele, NumSerie, NumAppareil, TypeEndoscope, MotifPrelevement, Traitement, CycleTraitement, TypeEauRincage, DateDernierLavage, NumeroESET, DateStockageESET, ConditionPrelevement, ConditionStockage, *CanalIds',
            canals: '++Id, Portee, VolumeLiquideInjecte, PrelevementId',

            prelevementQualifSalles: '++Id, Code, [Code], Observations, PersonnesPresentes, SystemeTraitementAir, LocalisationDeSalle, AutreLocalisationDeSalle, Classe, ProduitDangereux, SurfaceZAC, Volume, Plan, Temperature, Humidite, Luminosite, PressionAcoustique, TestFumee, PourcentageAirNeuf, PrelevementId, Type, *RepriseIds, *ZoneCompareIds, *SoufflageIds',


            soufflages: '++Id, Code,  [Code], Longueur, Largeur, Surface, Vitesse',
            reprises: '++Id, Code,  [Code], Longueur, Largeur, Surface, Vitesse',
            zoneCompares: '++Id, Code, [Code], Name, DifferentielPression, ProtectionEnvironnement',

            prelevements: '++Id, Code, [Code], OgiCode, Comment, SamplingJobId, ClientCode, SamplingPointId, *ConsommableIds, *FlaconIds',
            flacons: '++Id, Code, [Code], Type, Barcode, [Barcode]',
            consommables: '++Id, Type, NumeroLot, Expiration',

            lastUsedConsommables: '++Id, TypeOfService, Type, NumeroLot, Expiration',

            users: '++Id, Email, FirstName, LastName, Phone',

            operators: '++Id, Position, FirstName, LastName',

            samplingPoints: '++Id, Code,  [Code], Name, Address, City, ZipCode',

            pointageJournaliers: '++Id, DepartDomicile, DebutJournee, FinJournee, ArriveeDomicile, *PointagePauseIds',
            pointagePauses: '++Id, Debut, Fin',

            // Appareils of the user            
            appareils: '++Id, Code,  [Code], Type, Marque, Modele, NumeroInterne',

        });

        // this.on('populate', () => this.populate()); // populate event happens at the first opening of the db
        this.open()
            .catch(e => {
                return this.handleError(e);
            });
    }

    async populate() {
        // await db.transaction('rw', db.interventions, db.pictures, async () => {

        //     const lastRiskId = await db.pictures.bulkAdd([
        //         {
        //             Code: 'RCode1',
        //             Name: 'Rat',
        //             PictogramName: 'ATEX'
        //         },
        //         {
        //             Code: 'RCode2',
        //             Name: 'Raton',
        //             PictogramName: 'ATEX'
        //         },
        //         {
        //             Code: 'RCode4',
        //             Name: 'Ratoune',
        //             PictogramName: 'ATEX'
        //         }
        //     ]);
        //     const lastIdentifiedRIskId = await db.pictures.bulkAdd([
        //         {
        //             // riskAnalysisId,
        //             Position: 1,
        //             Comment: 'Feed the birds',
        //             // otherMeanOfPreventionDescription: ''
        //             RiskId: lastRiskId - 2
        //         },
        //         {
        //             // riskAnalysisId,
        //             Position: 2,
        //             Comment: 'Watch a movie',
        //             RiskId: lastRiskId - 1
        //         },
        //         {
        //             // riskAnalysisId,
        //             Position: 3,
        //             Comment: 'Have some sleep',
        //             RiskId: lastRiskId
        //         }
        //     ]);

        //     const ra1 = await db.riskAnalysis.add({
        //         Code: 'RACocode1',
        //         Status: 1,
        //         IdentifiedRiskEntityIds: [lastIdentifiedRIskId - 2, lastIdentifiedRIskId - 1]
        //     });
        //     const ra2 = await db.riskAnalysis.add({
        //         Code: 'RACocode2',
        //         Status: 1,
        //         IdentifiedRiskEntityIds: [lastIdentifiedRIskId]
        //     });

        //     await db.interventions.add({
        //         Code: 1234,
        //         RedactorPUID: 'FNR8',
        //         RiskAnalysisId: ra1
        //     });

        //     await db.interventions.add({
        //         Code: 12345,
        //         RedactorPUID: 'HE4I',
        //         RiskAnalysisId: ra2
        //     });
        // });
    }

    async resetDatabase() {
        await db.transaction('rw', [
            db.interventions, db.samplingPoints, db.operators, db.flacons,
            db.pointageJournaliers, db.pointagePauses, db.users, db.consommables, db.lastUsedConsommables,
            db.zones, db.generateurs, db.prelevementAirs, db.prelevementSurfaces, db.prelevements, db.prelevementGenerateurs,
            db.endoscopes, db.canals, db.prelevementQualifSalles, db.appareils, db.reprises, db.soufflages, db.zoneCompares
        ], async () => {

            await this.interventions.clear();

            await this.zones.clear();
            await this.prelevementAirs.clear();
            await this.prelevementSurfaces.clear();

            await this.generateurs.clear();
            await this.prelevementGenerateurs.clear();

            await this.endoscopes.clear();
            await this.canals.clear();

            await this.prelevementQualifSalles.clear();
            await this.appareils.clear();
            await this.soufflages.clear();
            await this.reprises.clear();
            await this.zoneCompares.clear();

            await this.prelevements.clear();
            await this.samplingPoints.clear();
            await this.flacons.clear();
            await this.consommables.clear();
            await this.lastUsedConsommables.clear();

            await this.operators.clear();
            await this.pointageJournaliers.clear();
            await this.pointagePauses.clear();
            await this.users.clear();

        })
    }

    // async changeInterventionStatus(int: Intervention) {
    //     const ie = await this.getInterventionEntityByCode(int.Code)
    //     if (!ie || !ie.Id) {
    //         return;
    //     }
    //     await db.interventions.update(ie.Id, {
    //         Status: int.Status
    //     });
    //     return true;
    // }

    // async changeZoneTaskStatus(zone: Zone) {
    //     const ze = await this.getZoneEntityByCode(zone.Code)
    //     if (!ze || !ze.Id) {
    //         return;
    //     }
    //     await db.zones.update(ze.Id, {
    //         TaskStatus: zone.TaskStatus
    //     });
    //     return true;
    // }

    // async changeGenerateurTaskStatus(gen: Generateur) {
    //     const ge = await this.getGenerateurEntityByCode(gen.Code)
    //     if (!ge || !ge.Id) {
    //         return;
    //     }
    //     await db.generateurs.update(ge.Id, {
    //         TaskStatus: gen.TaskStatus
    //     });
    //     return true;
    // }

    // async changeEndoscopeTaskStatus(endoscope: Endoscope) {
    //     const ee = await this.getEndoscopeEntityByCode(endoscope.Code)
    //     if (!ee || !ee.Id) {
    //         return;
    //     }
    //     await db.endoscopes.update(ee.Id, {
    //         TaskStatus: endoscope.TaskStatus
    //     });
    //     return true;
    // }
    // #region INTERVENTION
    // async addIntervention(int: Intervention) {

    //     await db.transaction('rw', [
    //         db.interventions, db.users,
    //         db.zones, db.prelevementAirs, db.prelevementSurfaces,
    //         db.prelevementGenerateurs, db.generateurs,
    //         db.prelevements, db.samplingPoints, db.flacons,
    //         db.endoscopes, db.canals, db.prelevementQualifSalles, db.appareils], async () => {
    //             const ie = mapper.map(int, Intervention, InterventionEntity);

    //             const interventionId = await db.interventions.add(ie);
    //             // if (int.SamplingPoint) {
    //             //     await this.attachSamplingPoint(int.SamplingPoint, interventionId);
    //             // }

    //             if (int.Sampler) {
    //                 await this.attachUser(int.Sampler, interventionId, true);
    //             }

    //             // if (int.Contact) {
    //             //     await this.attachUser(int.Contact, interventionId, false);
    //             // }
    //             for (let i = 0; i < int.ZoneList.length; i++) {
    //                 await this.attachZone(int.ZoneList[i], interventionId);
    //             }

    //             for (let i = 0; i < int.GenerateurDialyseList.length; i++) {
    //                 await this.attachGenerateur(int.GenerateurDialyseList[i], interventionId);
    //             }

    //             for (let i = 0; i < int.EndoscopeList.length; i++) {
    //                 await this.attachEndoscope(int.EndoscopeList[i], interventionId);
    //             }

    //             return interventionId;
    //         })
    // }

    // async getInterventionEntityById(id: number) {
    //     return await db.interventions.where('Id').equals(id).first(async ie => {
    //         return ie;
    //     });
    // }

    // async getInterventionEntityByCode(code: string) {
    //     return await db.interventions.where('Code').equals(code).first(async ie => {
    //         return ie;
    //     });
    // }

    // async getInterventionList() {
    //     const interventionList = await Promise.all(
    //         await db.interventions.toArray(ies => {
    //             return ies.map(async ie => {
    //                 // const intervention = mapper.map(ie, InterventionEntity, Intervention);
    //                 // if (ie?.SamplingPointId) {
    //                 //     intervention.SamplingPoint = await this.getSamplingPointById(ie.SamplingPointId);
    //                 // }
    //                 const intervention = await this.getInterventionByCode(ie.Code);
    //                 return intervention;
    //             });
    //         })
    //     );
    //     return interventionList;
    // }

    // async getInterventionByCode(code: string) {
    //     return await db.interventions.where('Code').equals(code).first(async ie => {
    //         const intervention = mapper.map(ie, InterventionEntity, Intervention);

    //         if (ie?.ZoneIds) {
    //             for (let i = 0; i < ie.ZoneIds.length; i++) {
    //                 intervention.ZoneList.push(await this.getZoneById(ie.ZoneIds[i]));
    //             }
    //         }

    //         if (ie?.GenerateurIds) {
    //             for (let i = 0; i < ie?.GenerateurIds.length; i++) {
    //                 intervention.GenerateurDialyseList.push(await this.getGenerateurById(ie?.GenerateurIds[i]));
    //             }
    //         }

    //         if (ie?.EndoscopeIds) {
    //             for (let i = 0; i < ie?.EndoscopeIds.length; i++) {
    //                 intervention.EndoscopeList.push(await this.getEndoscopeById(ie?.EndoscopeIds[i]));
    //             }
    //         }
    //         return intervention;
    //     })
    // }

    // async deleteIntervention(code: string) {
    //     await db.interventions.where('Code').equals(code).first(async ie => {

    //         // if (ie?.SamplingPointId) {
    //         //     await db.samplingPoints.where('Id').equals(ie?.SamplingPointId).delete();
    //         // }
    //         if (ie?.ZoneIds && ie?.ZoneIds?.length > 0) {
    //             for (let i = 0; i < ie.ZoneIds.length; i++) {

    //                 await db.zones.where('Id').equals(ie.ZoneIds[i]).toArray(async zes => {
    //                     if (!zes)
    //                         return;
    //                     for (let j = 0; j < zes.length; j++) {
    //                         const ze = await db.getZoneEntityById(zes[j].Id!)

    //                         if (ze?.PrelevementQualifSalleId) {
    //                             const qse = await db.getQualifSalleEntityById(ze?.PrelevementQualifSalleId!);
    //                             for (let q = 0; q < qse?.AppareilIds?.length!; q++) {
    //                                 await db.appareils.where('Id').equals(qse?.AppareilIds![q]!).delete();
    //                             }
    //                             await db.prelevementQualifSalles.where('Id').equals(qse?.Id!).delete();
    //                         }

    //                         for (let m = 0; m < ze?.PrelevementAirIds?.length!; m++) {
    //                             const pae = await db.getPrelevementAirEntityById(ze?.PrelevementAirIds[m]!);

    //                             const pe = await db.getPrelevementEntityById(pae?.PrelevementId!);

    //                             for (let c = 0; c < pe?.ConsommableIds?.length!; c++) {
    //                                 await db.consommables.where('Id').equals(pe?.ConsommableIds[c]!).delete();
    //                             }

    //                             for (let f = 0; f < pe?.FlaconIds?.length!; f++) {
    //                                 await db.flacons.where('Id').equals(pe?.FlaconIds[f]!).delete();
    //                             }

    //                             await db.samplingPoints.where('Id').equals(pe?.SamplingPointId!).delete();
    //                             await db.prelevements.where('Id').equals(pae?.PrelevementId!).delete();
    //                             await db.prelevementAirs.where('Id').equals(pae?.Id!).delete();
    //                         }

    //                         for (let m = 0; m < ze?.PrelevementSurfaceIds?.length!; m++) {
    //                             const pse = await db.getPrelevementSurfaceEntityById(ze?.PrelevementSurfaceIds[m]!);

    //                             const pe = await db.getPrelevementEntityById(pse?.PrelevementId!);

    //                             for (let c = 0; c < pe?.ConsommableIds?.length!; c++) {
    //                                 await db.consommables.where('Id').equals(pe?.ConsommableIds[c]!).delete();
    //                             }

    //                             for (let f = 0; f < pe?.FlaconIds?.length!; f++) {
    //                                 await db.flacons.where('Id').equals(pe?.FlaconIds[f]!).delete();
    //                             }

    //                             await db.samplingPoints.where('Id').equals(pe?.SamplingPointId!).delete();
    //                             await db.prelevements.where('Id').equals(pse?.PrelevementId!).delete();
    //                             await db.prelevementSurfaces.where('Id').equals(pse?.Id!).delete();
    //                         }

    //                         await db.zones.where('Id').equals(ze?.Id!).delete();
    //                     }
    //                 })
    //             }
    //         }

    //         if (ie?.GenerateurIds && ie?.GenerateurIds?.length > 0) {
    //             for (let i = 0; i < ie.GenerateurIds.length; i++) {

    //                 await db.generateurs.where('Id').equals(ie.GenerateurIds[i]).toArray(async aes => {
    //                     if (!aes)
    //                         return;
    //                     for (let j = 0; j < aes.length; j++) {
    //                         const ae = await db.getGenerateurEntityById(aes[j].Id!)

    //                         for (let m = 0; m < ae?.PrelevementGenerateurDialyseIds?.length!; m++) {
    //                             const ge = await db.getPrelevementGenerateurEntityById(ae?.PrelevementGenerateurDialyseIds[m]!);

    //                             const pe = await db.getPrelevementEntityById(ge?.PrelevementId!);

    //                             for (let c = 0; c < pe?.ConsommableIds?.length!; c++) {
    //                                 await db.consommables.where('Id').equals(pe?.ConsommableIds[c]!).delete();
    //                             }

    //                             for (let f = 0; f < pe?.FlaconIds?.length!; f++) {
    //                                 await db.flacons.where('Id').equals(pe?.FlaconIds[f]!).delete();
    //                             }

    //                             await db.samplingPoints.where('Id').equals(pe?.SamplingPointId!).delete();
    //                             await db.prelevements.where('Id').equals(ge?.PrelevementId!).delete();
    //                             await db.generateurs.where('Id').equals(ge?.Id!).delete();
    //                         }

    //                         await db.generateurs.where('Id').equals(ae?.Id!).delete();
    //                     }

    //                 })
    //             }
    //         }
    //         await db.interventions.where('Code').equals(code).delete();
    //     })
    // }
    // #endregion INTERVENTION

    // #region ZONE
    // async getZoneByCodeWithChildren(code: string) {
    //     return await db.zones.where('Code').equals(code).first(async ze => {
    //         const z = mapper.map(ze, ZoneEntity, Zone);

    //         if (ze?.PrelevementAirIds) {
    //             for (let i = 0; i < ze.PrelevementAirIds.length; i++) {
    //                 z.PrelevementAirList.push(await this.getPrelevementAirById(ze.PrelevementAirIds[i]));
    //             }
    //         }
    //         if (ze?.PrelevementSurfaceIds) {
    //             for (let i = 0; i < ze.PrelevementSurfaceIds.length; i++) {
    //                 z.PrelevementSurfaceList.push(await this.getPrelevementSurfaceById(ze.PrelevementSurfaceIds[i]));
    //             }
    //         }

    //         if (ze?.PrelevementQualifSalleId) {
    //             z.PrelevementQualifSalle = await this.getQualifSalleById(ze.PrelevementQualifSalleId)
    //         }

    //         return z;
    //     });
    // }

    // async getZoneEntityByCode(code: string) {
    //     return await db.zones.where('Code').equals(code).first(async me => {
    //         return me;
    //     });
    // }

    // async getZoneEntityById(id: number) {
    //     return await db.zones.where('Id').equals(id).first(async ze => {
    //         return ze;
    //     });
    // }
    // async getZoneById(id: number) {
    //     return await db.zones.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, ZoneEntity, Zone);
    //         if (ze?.PrelevementAirIds) {
    //             for (let i = 0; i < ze.PrelevementAirIds.length; i++) {
    //                 z.PrelevementAirList.push(await db.getPrelevementAirById(ze.PrelevementAirIds[i]));
    //             }
    //         }
    //         if (ze?.PrelevementSurfaceIds) {
    //             for (let i = 0; i < ze.PrelevementSurfaceIds.length; i++) {
    //                 z.PrelevementSurfaceList.push(await db.getPrelevementSurfaceById(ze.PrelevementSurfaceIds[i]));
    //             }
    //         }

    //         if (ze?.PrelevementQualifSalleId) {
    //             z.PrelevementQualifSalle = await db.getQualifSalleById(ze?.PrelevementQualifSalleId);
    //         }
    //         return z;
    //     });
    // }

    // async attachZone(zone: Zone, interventionId: number) {
    //     let zoneId: number;
    //     const ze = mapper.map(zone, Zone, ZoneEntity);

    //     const ie = await this.getInterventionEntityById(interventionId);
    //     zoneId = await db.zones.add(ze);
    //     await db.interventions.update(interventionId, {
    //         ZoneIds: ie?.ZoneIds ? [...ie.ZoneIds, zoneId] : [zoneId]
    //     });

    //     if (zone.PrelevementAirList?.length > 0) {
    //         for (let i = 0; i < zone.PrelevementAirList.length; i++) {
    //             await this.attachPrelevementAir(zone.PrelevementAirList[i], zoneId);
    //         }
    //     }

    //     if (zone.PrelevementSurfaceList?.length > 0) {
    //         for (let i = 0; i < zone.PrelevementSurfaceList.length; i++) {
    //             await this.attachPrelevementSurface(zone.PrelevementSurfaceList[i], zoneId);
    //         }
    //     }

    //     if (zone.PrelevementQualifSalle) {
    //         await this.attachQualifSalle(zone.PrelevementQualifSalle, zoneId);
    //     }

    //     return zoneId;
    // }

    // async updateZone(zone: Zone) {
    //     let zme = await this.getZoneEntityByCode(zone.Code);
    //     if (!zme || !zme.Id) {
    //         return false;
    //     }

    //     if (zme.PrelevementAirIds?.length > 0) {
    //         for (let i = 0; i < zme.PrelevementAirIds?.length; i++) {
    //             let pae = await this.getPrelevementAirEntityById(zme.PrelevementAirIds[i]);
    //             if (pae) {
    //                 mapper.mutate(zone.PrelevementAirList[i], pae, PrelevementAir, PrelevementAirEntity);
    //                 await db.prelevementAirs.update(zme.PrelevementAirIds[i], pae);

    //                 for (let j = 0; j < zone.PrelevementAirList[i].Prelevement.FlaconList.length; j++) {
    //                     let fe = await this.getFlaconEntityByCode(zone.PrelevementAirList[i].Prelevement.FlaconList[j].Code);
    //                     if (fe && fe.Id) {
    //                         mapper.mutate(zone.PrelevementAirList[i].Prelevement.FlaconList[j], fe, Flacon, FlaconEntity);
    //                         await db.flacons.update(fe.Id, zone.PrelevementAirList[i].Prelevement.FlaconList[j]);
    //                     }
    //                 }
    //             }
    //         }
    //     }

    //     if (zme.PrelevementSurfaceIds?.length > 0) {
    //         for (let i = 0; i < zme.PrelevementSurfaceIds?.length; i++) {
    //             let pae = await this.getPrelevementSurfaceEntityById(zme.PrelevementSurfaceIds[i]);
    //             if (pae) {
    //                 mapper.mutate(zone.PrelevementSurfaceList[i], pae, PrelevementSurface, PrelevementSurfaceEntity);
    //                 await db.prelevementSurfaces.update(zme.PrelevementSurfaceIds[i], pae);

    //                 for (let j = 0; j < zone.PrelevementSurfaceList[i].Prelevement.FlaconList.length; j++) {
    //                     let fe = await this.getFlaconEntityByCode(zone.PrelevementSurfaceList[i].Prelevement.FlaconList[j].Code);
    //                     if (fe && fe.Id) {
    //                         mapper.mutate(zone.PrelevementSurfaceList[i].Prelevement.FlaconList[j], fe, Flacon, FlaconEntity);
    //                         await db.flacons.update(fe.Id, zone.PrelevementSurfaceList[i].Prelevement.FlaconList[j]);
    //                     }
    //                 }
    //             }
    //         }
    //     }

    //     if (zme.PrelevementQualifSalleId && zone.PrelevementQualifSalle) {
    //         let qse = await this.getQualifSalleEntityById(zme.PrelevementQualifSalleId);
    //         if (qse) {
    //             mapper.mutate(zone.PrelevementQualifSalle, qse, PrelevementQualifSalle, PrelevementQualifSalleEntity);
    //             await db.prelevementQualifSalles.update(zme.PrelevementQualifSalleId, zone.PrelevementQualifSalle);

    //         }
    //         for (let j = 0; j < zone.PrelevementQualifSalle.AppareilQualifList.length; j++) {
    //             let ae = await this.getAppareilEntityByCode(zone.PrelevementQualifSalle.AppareilQualifList[j].Code);
    //             if (ae && ae.Id) {
    //                 mapper.mutate(zone.PrelevementQualifSalle.AppareilQualifList[j], ae, Appareil, AppareilEntity);
    //                 await db.appareils.update(ae.Id, zone.PrelevementQualifSalle.AppareilQualifList[j]);
    //             }
    //         }

    //         for (let j = 0; j < zone.PrelevementQualifSalle.SoufflageList.length; j++) {
    //             let ae = await this.getSoufflageEntityByCode(zone.PrelevementQualifSalle.SoufflageList[j].Code);
    //             if (ae && ae.Id) {
    //                 mapper.mutate(zone.PrelevementQualifSalle.SoufflageList[j], ae, Soufflage, SoufflageEntity);
    //                 await db.soufflages.update(ae.Id, zone.PrelevementQualifSalle.SoufflageList[j]);
    //             }
    //         }

    //         for (let j = 0; j < zone.PrelevementQualifSalle.RepriseList.length; j++) {
    //             let ae = await this.getRepriseEntityByCode(zone.PrelevementQualifSalle.RepriseList[j].Code);
    //             if (ae && ae.Id) {
    //                 mapper.mutate(zone.PrelevementQualifSalle.RepriseList[j], ae, Reprise, RepriseEntity);
    //                 await db.reprises.update(ae.Id, zone.PrelevementQualifSalle.RepriseList[j]);
    //             }
    //         }

    //         for (let j = 0; j < zone.PrelevementQualifSalle.ZoneCompareList.length; j++) {
    //             let ae = await this.getZoneCompareEntityByCode(zone.PrelevementQualifSalle.ZoneCompareList[j].Code);
    //             if (ae && ae.Id) {
    //                 mapper.mutate(zone.PrelevementQualifSalle.ZoneCompareList[j], ae, ZoneCompare, ZoneCompareEntity);
    //                 await db.zoneCompares.update(ae.Id, zone.PrelevementQualifSalle.ZoneCompareList[j]);
    //             }
    //         }
    //     }

    //     mapper.mutate(zone, zme, Zone, ZoneEntity);
    //     await db.zones.update(zme.Id, zme);

    //     return true;
    // }
    // #endregion ZONE

    // #region PRELEVEMENT AIR
    // async getPrelevementAirEntityById(id: number) {
    //     return await db.prelevementAirs.where('Id').equals(id).first(async ze => {
    //         return ze;
    //     });
    // }

    // async getPrelevementAirById(id: number) {
    //     return await db.prelevementAirs.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, PrelevementAirEntity, PrelevementAir);

    //         if (ze?.PrelevementId) {
    //             z.Prelevement = await this.getPrelevementById(ze?.PrelevementId)
    //         }

    //         return z;
    //     });
    // }

    // async attachPrelevementAir(pa: PrelevementAir, zoneId: number) {
    //     let paId: number;
    //     const pae = mapper.map(pa, PrelevementAir, PrelevementAirEntity);

    //     const ie = await this.getZoneEntityById(zoneId);
    //     paId = await db.prelevementAirs.add(pae);
    //     await db.zones.update(zoneId, {
    //         PrelevementAirIds: ie?.PrelevementAirIds ? [...ie.PrelevementAirIds, paId] : [paId]
    //     });

    //     if (pa.Prelevement) {
    //         await this.attachPrelevementToAir(pa.Prelevement, paId);
    //     }

    //     return paId;
    // }
    // #endregion PRELEVEMENT AIR

    // #region PRELEVEMENT SURFACE
    // async getPrelevementSurfaceEntityById(id: number) {
    //     return await db.prelevementSurfaces.where('Id').equals(id).first(async ze => {
    //         return ze;
    //     });
    // }

    // async getPrelevementSurfaceById(id: number) {
    //     return await db.prelevementSurfaces.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, PrelevementSurfaceEntity, PrelevementSurface);

    //         if (ze?.PrelevementId) {
    //             z.Prelevement = await this.getPrelevementById(ze?.PrelevementId)
    //         }

    //         return z;
    //     });
    // }
    // async attachPrelevementSurface(ps: PrelevementSurface, zoneId: number) {
    //     let psId: number;
    //     const pse = mapper.map(ps, PrelevementSurface, PrelevementSurfaceEntity);

    //     const ze = await this.getZoneEntityById(zoneId);
    //     psId = await db.prelevementSurfaces.add(pse);
    //     await db.zones.update(zoneId, {
    //         PrelevementSurfaceIds: ze?.PrelevementSurfaceIds ? [...ze.PrelevementSurfaceIds, psId] : [psId]
    //     });

    //     if (ps.Prelevement) {
    //         await this.attachPrelevementToSurface(ps.Prelevement, psId);
    //     }

    //     return psId;
    // }
    // #endregion PRELEVEMENT SURFACE

    // #region Qualif
    // async getQualifSalleEntityById(id: number) {
    //     return await db.prelevementQualifSalles.where('Id').equals(id).first(async ze => {
    //         return ze;
    //     });
    // }

    // async getQualifSalleById(id: number) {
    //     return await db.prelevementQualifSalles.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, PrelevementQualifSalleEntity, PrelevementQualifSalle);

    //         if (ze?.PrelevementId) {
    //             z.Prelevement = await this.getPrelevementById(ze?.PrelevementId)
    //         }

    //         if (ze?.AppareilIds) {
    //             for (let i = 0; i < ze.AppareilIds.length; i++) {
    //                 z.AppareilQualifList.push(await db.getAppareilById(ze.AppareilIds[i]));
    //             }
    //         }

    //         if (ze?.SoufflageIds) {
    //             for (let i = 0; i < ze.SoufflageIds.length; i++) {
    //                 z.SoufflageList.push(await db.getSoufflageById(ze.SoufflageIds[i]));
    //             }
    //         }

    //         if (ze?.RepriseIds) {
    //             for (let i = 0; i < ze.RepriseIds.length; i++) {
    //                 z.RepriseList.push(await db.getRepriseById(ze.RepriseIds[i]));
    //             }
    //         }

    //         if (ze?.ZoneCompareIds) {
    //             for (let i = 0; i < ze.ZoneCompareIds.length; i++) {
    //                 z.ZoneCompareList.push(await db.getZoneCompareById(ze.ZoneCompareIds[i]));
    //             }
    //         }
    //         return z;
    //     });
    // }

    // async attachQualifSalle(ps: PrelevementQualifSalle, zoneId: number) {
    //     let pqsId: number;
    //     const pse = mapper.map(ps, PrelevementQualifSalle, PrelevementQualifSalleEntity);

    //     const ze = await this.getZoneEntityById(zoneId);
    //     pqsId = await db.prelevementQualifSalles.add(pse);
    //     await db.zones.update(zoneId, {
    //         PrelevementQualifSalleId: pqsId
    //     });

    //     if (ps.Prelevement) {
    //         await this.attachPrelevementToQualifSalle(ps.Prelevement, pqsId);
    //     }

    //     if (ps.AppareilQualifList?.length > 0) {
    //         for (let i = 0; i < ps.AppareilQualifList?.length; i++) {
    //             await this.attachAppareil(ps.AppareilQualifList[i], pqsId);
    //         }
    //     }

    //     if (ps.SoufflageList?.length > 0) {
    //         for (let i = 0; i < ps.SoufflageList?.length; i++) {
    //             await this.attachSoufflage(ps.SoufflageList[i], pqsId);
    //         }
    //     }

    //     if (ps.RepriseList?.length > 0) {
    //         for (let i = 0; i < ps.RepriseList?.length; i++) {
    //             await this.attachReprise(ps.RepriseList[i], pqsId);
    //         }
    //     }

    //     if (ps.ZoneCompareList?.length > 0) {
    //         for (let i = 0; i < ps.ZoneCompareList?.length; i++) {
    //             await this.attachZoneCompare(ps.ZoneCompareList[i], pqsId);
    //         }
    //     }
    //     return pqsId;
    // }
    // #endregion Qualif

    // #region Appareil
    // async getAppareilEntityByCode(code: string) {
    //     return await db.appareils.where('Code').equals(code).first(async me => {
    //         return me;
    //     });
    // }

    // async getAppareilById(id: number) {
    //     return await db.appareils.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, AppareilEntity, Appareil)

    //         return z;
    //     });
    // }

    // async getAppareilEntityById(id: number) {
    //     return await db.appareils.where('Id').equals(id).first(async ze => {
    //         return ze;
    //     });
    // }

    // async attachAppareil(ps: Appareil, qualifSalleId: number) {
    //     let aeId: number;
    //     const ae = mapper.map(ps, Appareil, AppareilEntity);

    //     const qse = await this.getQualifSalleEntityById(qualifSalleId);
    //     aeId = await db.appareils.add(ae);
    //     await db.prelevementQualifSalles.update(qualifSalleId, {
    //         AppareilIds: qse?.AppareilIds ? [...qse.AppareilIds, aeId] : [aeId]
    //     });

    //     return aeId;
    // }

    // #endregion Appareil

    // #region SOUFFLAGE

    // async getSoufflageEntityByCode(code: string) {
    //     return await db.soufflages.where('Code').equals(code).first(async me => {
    //         return me;
    //     });
    // }

    // async getSoufflageEntityById(id: number) {
    //     return await db.soufflages.where('Id').equals(id).first(async se => {
    //         return se;
    //     });
    // }

    // async getSoufflageById(id: number) {
    //     return await db.soufflages.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, SoufflageEntity, Soufflage)

    //         return z;
    //     });
    // }

    // async attachSoufflage(ps: Soufflage, qualifSalleId: number) {
    //     let seId: number;
    //     const se = mapper.map(ps, Soufflage, SoufflageEntity);

    //     const qse = await this.getQualifSalleEntityById(qualifSalleId);
    //     seId = await db.soufflages.add(se);
    //     await db.prelevementQualifSalles.update(qualifSalleId, {
    //         SoufflageIds: qse?.SoufflageIds ? [...qse.SoufflageIds, seId] : [seId]
    //     });

    //     return seId;
    // }
    // #endregion

    // #region REPRISE
    // async getRepriseEntityByCode(code: string) {
    //     return await db.reprises.where('Code').equals(code).first(async me => {
    //         return me;
    //     });
    // }

    // async getRepriseEntityById(id: number) {
    //     return await db.reprises.where('Id').equals(id).first(async se => {
    //         return se;
    //     });
    // }
    
    // async getRepriseById(id: number) {
    //     return await db.reprises.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, RepriseEntity, Reprise)

    //         return z;
    //     });
    // }

    // async attachReprise(ps: Reprise, qualifSalleId: number) {
    //     let reId: number;
    //     const re = mapper.map(ps, Reprise, RepriseEntity);

    //     const qse = await this.getQualifSalleEntityById(qualifSalleId);
    //     reId = await db.reprises.add(re);
    //     await db.prelevementQualifSalles.update(qualifSalleId, {
    //         RepriseIds: qse?.RepriseIds ? [...qse.RepriseIds, reId] : [reId]
    //     });

    //     return reId;
    // }
    // #endregion

    // #region ZONE COMPARE
    // async getZoneCompareEntityByCode(code: string) {
    //     return await db.zoneCompares.where('Code').equals(code).first(async me => {
    //         return me;
    //     });
    // }

    // async getZoneCompareEntityById(id: number) {
    //     return await db.zoneCompares.where('Id').equals(id).first(async se => {
    //         return se;
    //     });
    // }

    // async getZoneCompareById(id: number) {
    //     return await db.zoneCompares.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, ZoneCompareEntity, ZoneCompare)

    //         return z;
    //     });
    // }
    
    // async attachZoneCompare(ps: ZoneCompare, qualifSalleId: number) {
    //     let zceId: number;
    //     const zce = mapper.map(ps, ZoneCompare, ZoneCompareEntity);

    //     const qse = await this.getQualifSalleEntityById(qualifSalleId);
    //     zceId = await db.zoneCompares.add(zce);
    //     await db.prelevementQualifSalles.update(qualifSalleId, {
    //         ZoneCompareIds: qse?.ZoneCompareIds ? [...qse.ZoneCompareIds, zceId] : [zceId]
    //     });

    //     return zceId;
    // }
    // #endregion

    // #region GENERATEUR
    // async getGenerateurEntityById(id: number) {
    //     return await db.generateurs.where('Id').equals(id).first(async ze => {
    //         return ze;
    //     });
    // }

    // async getGenerateurById(id: number) {
    //     return await db.generateurs.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, GenerateurEntity, Generateur);
    //         if (ze?.PrelevementGenerateurDialyseIds) {
    //             for (let i = 0; i < ze.PrelevementGenerateurDialyseIds.length; i++) {
    //                 z.PrelevementGenerateurDialyseList.push(await db.getPrelevementGenerateurDialyseById(ze.PrelevementGenerateurDialyseIds[i]));
    //             }
    //         }

    //         return z;
    //     });
    // }

    // async getGenerateurEntityByCode(code: string) {
    //     return await db.generateurs.where('Code').equals(code).first(async me => {
    //         return me;
    //     });
    // }

    // async getGenerateurByCodeWithChildren(code: string) {
    //     return await db.generateurs.where('Code').equals(code).first(async ze => {
    //         const z = mapper.map(ze, GenerateurEntity, Generateur);

    //         if (ze?.PrelevementGenerateurDialyseIds) {
    //             for (let i = 0; i < ze.PrelevementGenerateurDialyseIds.length; i++) {
    //                 z.PrelevementGenerateurDialyseList.push(await this.getPrelevementGenerateurDialyseById(ze.PrelevementGenerateurDialyseIds[i]));
    //             }
    //         }

    //         return z;
    //     });
    // }

    // async attachGenerateur(app: Generateur, interventionId: number) {
    //     let appId: number;
    //     const ae = mapper.map(app, Generateur, GenerateurEntity);

    //     const ie = await this.getInterventionEntityById(interventionId);
    //     appId = await db.generateurs.add(ae);
    //     await db.interventions.update(interventionId, {
    //         GenerateurIds: ie?.GenerateurIds ? [...ie.GenerateurIds, appId] : [appId]
    //     });

    //     if (app.PrelevementGenerateurDialyseList?.length > 0) {
    //         for (let i = 0; i < app.PrelevementGenerateurDialyseList.length; i++) {
    //             await this.attachPrelevementGenerateurDialyse(app.PrelevementGenerateurDialyseList[i], appId);
    //         }
    //     }

    //     return appId;
    // }

    // async updateGenerateur(app: Generateur) {
    //     let zme = await this.getGenerateurEntityByCode(app.Code);
    //     if (!zme || !zme.Id) {
    //         return false;
    //     }

    //     if (zme.PrelevementGenerateurDialyseIds.length > 0) {
    //         for (let i = 0; i < zme.PrelevementGenerateurDialyseIds?.length; i++) {
    //             let pae = await this.getPrelevementGenerateurEntityById(zme.PrelevementGenerateurDialyseIds[i]);
    //             if (pae) {
    //                 mapper.mutate(app.PrelevementGenerateurDialyseList[i], pae, PrelevementGenerateurDialyse, PrelevementGenerateurDialyseEntity);
    //                 await db.prelevementGenerateurs.update(zme.PrelevementGenerateurDialyseIds[i], pae);

    //                 for (let j = 0; j < app.PrelevementGenerateurDialyseList[i].Prelevement.FlaconList.length; j++) {
    //                     let fe = await this.getFlaconEntityByCode(app.PrelevementGenerateurDialyseList[i].Prelevement.FlaconList[j].Code);
    //                     if (fe && fe.Id) {
    //                         mapper.mutate(app.PrelevementGenerateurDialyseList[i].Prelevement.FlaconList[j], fe, Flacon, FlaconEntity);
    //                         await db.flacons.update(fe.Id, app.PrelevementGenerateurDialyseList[i].Prelevement.FlaconList[j]);
    //                     }
    //                 }
    //             }
    //         }
    //     }

    //     mapper.mutate(app, zme, Generateur, GenerateurEntity);
    //     await db.generateurs.update(zme.Id, zme);

    //     return true;
    // }
    // #endregion GENERATEUR

    // #region PRELEVEMENT GENERATEUR DIALYSE
    // async getPrelevementGenerateurEntityById(id: number) {
    //     return await db.prelevementGenerateurs.where('Id').equals(id).first(async ze => {
    //         return ze;
    //     });
    // }

    // async getPrelevementGenerateurDialyseById(id: number) {
    //     return await db.prelevementGenerateurs.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, PrelevementGenerateurDialyseEntity, PrelevementGenerateurDialyse);

    //         if (ze?.PrelevementId) {
    //             z.Prelevement = await this.getPrelevementById(ze?.PrelevementId)
    //         }
    //         return z;
    //     });
    // }

    // async attachPrelevementGenerateurDialyse(app: PrelevementGenerateurDialyse, appId: number) {
    //     let gId: number;
    //     const ge = mapper.map(app, PrelevementGenerateurDialyse, PrelevementGenerateurDialyseEntity);

    //     const ae = await this.getGenerateurEntityById(appId);
    //     gId = await db.prelevementGenerateurs.add(ge);
    //     await db.generateurs.update(appId, {
    //         PrelevementGenerateurDialyseIds: ae?.PrelevementGenerateurDialyseIds ? [...ae.PrelevementGenerateurDialyseIds, gId] : [gId]
    //     });

    //     if (app.Prelevement) {
    //         await this.attachPrelevementToGenerateur(app.Prelevement, gId);
    //     }

    //     return gId;
    // }

    // #endregion GENERATEUR DIALYSE

    // #region ENDOSCOPE

    // async getEndoscopeEntityById(id: number) {
    //     return await db.endoscopes.where('Id').equals(id).first(async ze => {
    //         return ze;
    //     });
    // }

    // async getEndoscopeById(id: number) {
    //     return await db.endoscopes.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, EndoscopeEntity, Endoscope);
    //         if (ze?.CanalIds) {
    //             for (let i = 0; i < ze.CanalIds.length; i++) {
    //                 z.CanalEndoscopeList.push(await db.getCanalById(ze.CanalIds[i]));
    //             }
    //         }

    //         return z;
    //     });
    // }

    // async getEndoscopeEntityByCode(code: string) {
    //     return await db.endoscopes.where('Code').equals(code).first(async me => {
    //         return me;
    //     });
    // }

    // async getEndoscopeByCodeWithChildren(code: string) {
    //     return await db.endoscopes.where('Code').equals(code).first(async ze => {
    //         const z = mapper.map(ze, EndoscopeEntity, Endoscope);

    //         if (ze?.CanalIds) {
    //             for (let i = 0; i < ze.CanalIds.length; i++) {
    //                 z.CanalEndoscopeList.push(await this.getCanalById(ze.CanalIds[i]));
    //             }
    //         }

    //         return z;
    //     });
    // }

    // async attachEndoscope(endoscope: Endoscope, interventionId: number) {
    //     let endoId: number;
    //     const ae = mapper.map(endoscope, Endoscope, EndoscopeEntity);

    //     const ie = await this.getInterventionEntityById(interventionId);
    //     endoId = await db.endoscopes.add(ae);
    //     await db.interventions.update(interventionId, {
    //         EndoscopeIds: ie?.EndoscopeIds ? [...ie.EndoscopeIds, endoId] : [endoId]
    //     });

    //     if (endoscope.CanalEndoscopeList?.length > 0) {
    //         for (let i = 0; i < endoscope.CanalEndoscopeList.length; i++) {
    //             await this.attachCanal(endoscope.CanalEndoscopeList[i], endoId);
    //         }
    //     }

    //     return endoId;
    // }

    // async updateEndoscope(endo: Endoscope) {
    //     let ee = await this.getEndoscopeEntityByCode(endo.Code);
    //     if (!ee || !ee.Id) {
    //         return false;
    //     }

    //     if (ee.CanalIds.length > 0) {
    //         for (let i = 0; i < ee.CanalIds?.length; i++) {
    //             let pae = await this.getCanalEntityById(ee.CanalIds[i]);
    //             if (pae) {
    //                 mapper.mutate(endo.CanalEndoscopeList[i], pae, Canal, CanalEntity);
    //                 await db.canals.update(ee.CanalIds[i], pae);

    //                 for (let j = 0; j < endo.CanalEndoscopeList[i].Prelevement.FlaconList.length; j++) {
    //                     let fe = await this.getFlaconEntityByCode(endo.CanalEndoscopeList[i].Prelevement.FlaconList[j].Code);
    //                     if (fe && fe.Id) {
    //                         mapper.mutate(endo.CanalEndoscopeList[i].Prelevement.FlaconList[j], fe, Flacon, FlaconEntity);
    //                         await db.flacons.update(fe.Id, endo.CanalEndoscopeList[i].Prelevement.FlaconList[j]);
    //                     }
    //                 }
    //             }
    //         }
    //     }

    //     mapper.mutate(endo, ee, Endoscope, EndoscopeEntity);
    //     await db.endoscopes.update(ee.Id, ee);

    //     return true;
    // }
    // #endregion ENDOSCOPE

    // #region CANAL
    // async getCanalById(id: number) {
    //     return await db.canals.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, CanalEntity, Canal);

    //         if (ze?.PrelevementId) {
    //             z.Prelevement = await this.getPrelevementById(ze?.PrelevementId)
    //         }

    //         return z;
    //     });
    // }

    // async getCanalEntityById(id: number) {
    //     return await db.canals.where('Id').equals(id).first(async ze => {
    //         return ze;
    //     });
    // }

    // async attachCanal(canal: Canal, endoscopeId: number) {
    //     let canalId: number;
    //     const ce = mapper.map(canal, Canal, CanalEntity);

    //     const ee = await this.getEndoscopeEntityById(endoscopeId);
    //     canalId = await db.canals.add(ce);
    //     await db.endoscopes.update(endoscopeId, {
    //         CanalIds: ee?.CanalIds ? [...ee.CanalIds, canalId] : [canalId]
    //     });

    //     if (canal.Prelevement) {
    //         await this.attachPrelevementToCanal(canal.Prelevement, canalId);
    //     }

    //     return canalId;
    // }

    // #endregion CANAL

    // #region PRELEVEMENT

    // async getPrelevementEntityById(id: number) {
    //     return await db.prelevements.where('Id').equals(id).first(async ze => {
    //         return ze;
    //     });
    // }

    // async getPrelevementById(id: number) {
    //     return await db.prelevements.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, PrelevementEntity, Prelevement);

    //         if (ze?.SamplingPointId) {
    //             z.SamplingPoint = await this.getSamplingPointById(ze?.SamplingPointId)
    //         }

    //         if (ze?.FlaconIds) {
    //             for (let i = 0; i < ze.FlaconIds.length; i++) {
    //                 z.FlaconList.push(await db.getFlaconById(ze.FlaconIds[i]));
    //             }
    //         }

    //         if (ze?.ConsommableIds) {
    //             for (let i = 0; i < ze.ConsommableIds.length; i++) {
    //                 z.ConsommableList.push(await db.getConsommableById(ze.ConsommableIds[i]));
    //             }
    //         }
    //         return z;
    //     });
    // }

    // async getPrelevementEntityByCode(code: string) {
    //     return await db.prelevements.where('Code').equals(code).first(async ze => {
    //         return ze;
    //     });
    // }

    // async attachPrelevementToAir(p: Prelevement, paId: number) {
    //     let pId: number;
    //     const pe = mapper.map(p, Prelevement, PrelevementEntity);

    //     const pae = await this.getPrelevementAirEntityById(paId);
    //     pId = await db.prelevements.add(pe);
    //     await db.prelevementAirs.update(paId, {
    //         PrelevementId: pId
    //     });

    //     if (p.SamplingPoint) {
    //         await this.attachSamplingPoint(p.SamplingPoint, pId);
    //     }

    //     if (p.FlaconList?.length > 0) {
    //         for (let i = 0; i < p.FlaconList.length; i++) {
    //             await this.attachFlacon(p.FlaconList[i], pId);
    //         }
    //     }
    //     return pId;
    // }

    // async attachPrelevementToSurface(p: Prelevement, psId: number) {
    //     let pId: number;
    //     const pe = mapper.map(p, Prelevement, PrelevementEntity);

    //     const ae = await this.getPrelevementSurfaceById(psId);
    //     pId = await db.prelevements.add(pe);
    //     await db.prelevementSurfaces.update(psId, {
    //         PrelevementId: pId
    //     });

    //     if (p.SamplingPoint) {
    //         await this.attachSamplingPoint(p.SamplingPoint, pId);
    //     }
    //     if (p.FlaconList?.length > 0) {
    //         for (let i = 0; i < p.FlaconList.length; i++) {
    //             await this.attachFlacon(p.FlaconList[i], pId);
    //         }
    //     }
    //     return pId;
    // }

    // async attachPrelevementToGenerateur(p: Prelevement, gId: number) {
    //     let pId: number;
    //     const pe = mapper.map(p, Prelevement, PrelevementEntity);

    //     const pae = await this.getPrelevementGenerateurEntityById(gId);
    //     pId = await db.prelevements.add(pe);
    //     await db.prelevementGenerateurs.update(gId, {
    //         PrelevementId: pId
    //     });

    //     if (p.SamplingPoint) {
    //         await this.attachSamplingPoint(p.SamplingPoint, pId);
    //     }
    //     if (p.FlaconList?.length > 0) {
    //         for (let i = 0; i < p.FlaconList.length; i++) {
    //             await this.attachFlacon(p.FlaconList[i], pId);
    //         }
    //     }
    //     return pId;
    // }

    // async attachPrelevementToCanal(p: Prelevement, canalId: number) {
    //     let pId: number;
    //     const pe = mapper.map(p, Prelevement, PrelevementEntity);

    //     const ce = await this.getCanalEntityById(canalId);
    //     pId = await db.prelevements.add(pe);
    //     await db.canals.update(canalId, {
    //         PrelevementId: pId
    //     });

    //     if (p.SamplingPoint) {
    //         await this.attachSamplingPoint(p.SamplingPoint, pId);
    //     }
    //     if (p.FlaconList?.length > 0) {
    //         for (let i = 0; i < p.FlaconList.length; i++) {
    //             await this.attachFlacon(p.FlaconList[i], pId);
    //         }
    //     }
    //     return pId;
    // }

    // async attachPrelevementToQualifSalle(p: Prelevement, appId: number) {
    //     let pId: number;
    //     const pe = mapper.map(p, Prelevement, PrelevementEntity);

    //     const ce = await this.getAppareilEntityById(appId);
    //     pId = await db.prelevements.add(pe);
    //     await db.prelevementQualifSalles.update(appId, {
    //         PrelevementId: pId
    //     });

    //     if (p.SamplingPoint) {
    //         await this.attachSamplingPoint(p.SamplingPoint, pId);
    //     }

    //     return pId;
    // }
    // #endregion PRELEVEMENT

    // #region USER

    // async getUserById(id: number) {
    //     return await db.users.where('Id').equals(id).first(async ue => {
    //         const user = mapper.map(ue, UserEntity, User);
    //         return user;
    //     });
    // }

    // async attachUser(user: User, intId: number, forSampler: boolean) {
    //     let userId: number;
    //     const ue = mapper.map(user, User, UserEntity);

    //     userId = await db.users.add(ue);
    //     if (forSampler) {
    //         await db.interventions.update(intId, {
    //             SamplerId: userId
    //         });
    //     } else {
    //         await db.interventions.update(intId, {
    //             ContactId: userId
    //         });
    //     }
    //     return userId;
    // }

    // #endregion USER

    // #region SAMPLING POINT
    // async getSamplingPointById(samplingPointId: number) {
    //     return await db.samplingPoints.where('Id').equals(samplingPointId).first(async spe => {
    //         const samplingPoint = mapper.map(spe, SamplingPointEntity, SamplingPoint);
    //         return samplingPoint;
    //     });
    // }

    // async attachSamplingPoint(sp: SamplingPoint, pId: number) {
    //     let samplingPointId: number;
    //     const spe = mapper.map(sp, SamplingPoint, SamplingPointEntity);

    //     samplingPointId = await db.samplingPoints.add(spe);
    //     await db.prelevements.update(pId, {
    //         SamplingPointId: samplingPointId
    //     });
    //     return samplingPointId;

    // }
    // #endregion

    // #region FLACON
    // async getFlaconById(id: number) {

    //     return await db.flacons.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, FlaconEntity, Flacon);
    //         return z;
    //     });
    // }

    // async getFlaconEntityByCode(code: string) {
    //     return await db.flacons.where('Code').equals(code).first(async ze => {
    //         return ze;
    //     });
    // }

    // async checkIfBarcodeExists(code: string) {
    //     return await db.flacons.where('Barcode').equals(code).first(async ze => {
    //         return ze;
    //     });
    // }

    // async attachFlacon(flacon: Flacon, prelId: number) {
    //     let flaconId: number;
    //     const oe = mapper.map(flacon, Flacon, FlaconEntity);

    //     const ae = await this.getPrelevementEntityById(prelId);
    //     flaconId = await db.flacons.add(oe);
    //     await db.prelevements.update(prelId, {
    //         FlaconIds: ae?.FlaconIds ? [...ae.FlaconIds, flaconId] : [flaconId]
    //     });
    //     return flaconId;
    // }

    // #endregion FLACON

    // #region CONSOMMABLE
    // async getConsommableById(id: number) {

    //     return await db.consommables.where('Id').equals(id).first(async ze => {
    //         const z = mapper.map(ze, ConsommableEntity, Consommable);
    //         return z;
    //     });
    // }

    // async getConsommableEntityById(id: number) {
    //     return await db.consommables.where('Id').equals(id).first(async ze => {
    //         return ze;
    //     });
    // }

    // async attachConsommable(consommable: Consommable, prelCode: string) {
    //     let conId: number;
    //     const oe = mapper.map(consommable, Consommable, ConsommableEntity);

    //     const ae = await this.getPrelevementEntityByCode(prelCode);
    //     conId = await db.consommables.add(oe);
    //     if (ae && ae.Id) {
    //         await db.prelevements.update(ae.Id, {
    //             ConsommableIds: ae?.ConsommableIds ? [...ae.ConsommableIds, conId] : [conId]
    //         });
    //     }
    //     return conId;
    // }

    // async deleteConsommableById(id: number, prel: Prelevement) {
    //     await db.consommables.where('Id').equals(id).delete();

    //     const oe = await this.getPrelevementEntityByCode(prel.Code);
    //     if (oe && oe.Id) {
    //         _.remove(oe.ConsommableIds, x => x === id)
    //         await db.prelevements.update(oe.Id, {
    //             ConsommableIds: oe.ConsommableIds
    //         });
    //     }
    // }

    // #endregion CONSOMMABLE

    // #region LAST USED CONSOMMABLE
    async getLastUsedConsommableById(id: number) {

        return await db.lastUsedConsommables.where('Id').equals(id).first(async ze => {
            const z = mapper.map(ze, LastUsedConsommableEntity, Consommable);
            return z;
        });
    }

    async getLastUsedConsommableByType(type: number, typeOfService: number) {

        return await db.lastUsedConsommables.where('Type').equals(type).and(x => { return x.TypeOfService === typeOfService }).last(async ze => {
            const z = mapper.map(ze, LastUsedConsommableEntity, Consommable);
            return z;
        });
    }

    async getLastUsedConsommableEntityByType(type: number, typeOfService: number) {

        return await db.lastUsedConsommables.where('Type').equals(type).and(x => { return x.TypeOfService === typeOfService }).first(async ze => {
            return ze;
        });
    }

    async getLastUsedConsommableEntityByTypeOfService(typeOfService: number) {

        return await db.lastUsedConsommables.where('TypeOfService').equals(typeOfService).first(async ze => {
            return ze;
        });
    }

    async getLastUsedConsommableByTypeOfService(typeOfService: number) {

        return await db.lastUsedConsommables.where('TypeOfService').equals(typeOfService).first(async ze => {
            const z = mapper.map(ze, LastUsedConsommableEntity, Consommable);
            return z;
        });
    }

    async updateLastUsedConsommableByType(consommable: Consommable, typeOfService: number) {
        // = typeOfService === EServiceType.Dialyse ?
        // await this.getLastUsedConsommableEntityByTypeOfService(typeOfService) :
        const ae = await this.getLastUsedConsommableEntityByType(consommable.Type, typeOfService);
        if (ae && ae.Id) {
            mapper.mutate(consommable, ae, Consommable, LastUsedConsommableEntity);
            await db.lastUsedConsommables.update(ae.Id, ae);
        }
        else {
            const oe = mapper.map(consommable, Consommable, LastUsedConsommableEntity);
            oe.TypeOfService = typeOfService;
            await db.lastUsedConsommables.add(oe);
        }
    }
    // #endregion LAST USED CONSOMMABLE

    //#region OPERATOR

    async getOperatorEntityById(id: number) {
        return await db.operators.where('Id').equals(id).first(async oe => {
            return oe;
        });
    }

    async getOperatorByIdWithChildren(id: number) {
        return await db.operators.where('Id').equals(id).first(async oe => {
            const o = mapper.map(oe, OperatorEntity, Operator);

            return o;
        });
    }

    async attachOperator(operator: Operator, measureId: number) {
        let operatorId: number;
        const oe = mapper.map(operator, Operator, OperatorEntity);

        operatorId = await db.operators.add(oe);

        return operatorId;
    }

    // TODO ADD CASCADE !!!!!!!!!!!!!!!!!! FFWEF WEUFHWEFH IUWEFH IUWFUE
    async clearOperatorById(ids: number[]) {
        await db.operators.where('Id').anyOf(ids).toArray(async oe => {
            for (let i = 0; i < oe.length; i++) {
                if (oe && oe[i].Id !== undefined) {
                    await db.operators.where('Id').equals(oe[i].Id!).delete();
                }
            }
        })
    }
    //#endregion

    //#region POINTAGE

    // async getPointageJournalierEntityById(id: number) {
    //     return await db.pointageJournaliers.where('Id').equals(id).first(async ze => {
    //         return ze;
    //     });
    // }

    // async addPointageJournalier(pointage: PointageJournalier) {

    //     const pje = mapper.map(pointage, PointageJournalier, PointageJournalierEntity);

    //     const pointageJournalierId = await db.pointageJournaliers.add(pje);

    //     if (pointage.PointagePauseList && pointage.PointagePauseList.length > 0) {
    //         for (let i = 0; i < pointage.PointagePauseList.length; i++) {
    //             await this.attachPointagePause(pointage.PointagePauseList[i], pointageJournalierId);
    //         }
    //     }

    //     return pointageJournalierId;
    // }

    // async attachPointagePause(pause: PointagePause, pointageJournalierId: number) {

    //     const ppe = mapper.map(pause, PointagePause, PointagePauseEntity);
    //     const pe = await this.getPointageJournalierEntityById(pointageJournalierId);
    //     const pointagePauseId = await db.pointagePauses.add(ppe);
    //     await db.pointageJournaliers.update(pointageJournalierId, {
    //         PointagePauseIds: pe?.PointagePauseIds ? [...pe.PointagePauseIds, pointagePauseId] : [pointagePauseId]
    //     });

    //     return pointagePauseId;
    // }

    //#endregion

    async exportDB(cb: any) {
        const idbDatabase = db.backendDB();
        IDBExportImport.exportToJsonString(idbDatabase, cb);
    }

    importDB(jsonString: any) {
        const idbDatabase = db.backendDB();
        db.resetDatabase
        IDBExportImport.clearDatabase(idbDatabase, function (err: any) {
            if (!err) {
                IDBExportImport.importFromJsonString(idbDatabase, jsonString, function (err: any) {
                    if (!err) {
                        console.log('Imported data successfully');
                    }
                });
            }
        });
    }

    handleError(e: any): any {
        switch (e.name) {
            case 'AbortError':
                if (e.inner) {
                    return this.handleError(e.inner);
                }
                console.error('Abort error ' + e.message);
                break;
            case 'QuotaExceededError':
                console.error('QuotaExceededError ' + e.message);
                break;
            default:
                console.error(e);
                break;
        }
    }
}

export const db = new AppDB();
